import React from 'react';
import ReactDOM from 'react-dom';
import { FrameworkSiderBar } from '@liepin/react-framework4c-pc';


const $el = document.querySelector('#lp-sider-bar-container');
$el && ReactDOM.render(React.createElement(FrameworkSiderBar), $el);